var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "url(#paint0_linear_2271_4515)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_4515)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 26.6367C14.5 21.1139 18.9772 16.6367 24.5 16.6367C30.0229 16.6367 34.5 21.1139 34.5 26.6367C34.5 28.6182 33.923 30.467 32.9276 32.0219C32.7963 32.227 32.5694 32.351 32.326 32.351H16.674C16.4305 32.351 16.2038 32.227 16.0725 32.0219C15.077 30.467 14.5 28.6182 14.5 26.6367ZM21.8473 23.2283L25.6066 29.4939H23.1077L20.0098 24.3308C19.7054 23.8234 19.8699 23.1653 20.3773 22.8608C20.8847 22.5564 21.5429 22.7209 21.8473 23.2283Z",
    fill: "url(#paint1_linear_2271_4515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_4515",
    x1: 49,
    y1: 49,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F13741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4929E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_4515",
    x1: 24.5,
    y1: 16.6367,
    x2: 24.5,
    y2: 32.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_4515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14.5 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMeter);
export default __webpack_public_path__ + "static/media/red-meter.c6131f04098cd4c9804a53b43c191c8f.svg";
export { ForwardRef as ReactComponent };